import React from 'react';
import { SecurityContextTemplate, SecurityContextCommonProps } from 'framework/authorization';
import useLeaveService from 'domain/people/leave/shared/leaveService';

const LeaveContext = ({ permissionToCheck, children, id }: SecurityContextCommonProps) => {
  const { getPermissionsEntity } = useLeaveService();
  const CONTEXT_NAME = 'LEAVE_CONTEXT';

  return (
    <SecurityContextTemplate
      getPermissionsFunc={getPermissionsEntity}
      permissionToCheck={permissionToCheck}
      contextName={CONTEXT_NAME}
      id={id}
    >
      {children}
    </SecurityContextTemplate>
  );
};

export default LeaveContext;
